import EasyFormColumn from "../../components/Forms/EasyFormColumn";
import { AutocompleteFieldRender } from "../../components/Forms/Renders/AutocompleteFieldRender";
import { FieldHeaderRender } from "../../components/Forms/Renders/FieldHeaderRender";
import { TextFieldRender } from "../../components/Forms/Renders/TextFieldRender";
import { OverallCategoryEnum } from "../../models/enums/OrganisationOverallCategoryEnum";
import { SpecificCategoryEnum } from "../../models/enums/OrganisationSpecificCategoryEnum";


export default function getOrganisationInfoColumns(fieldPrefix?: string) {
    return ([
        new EasyFormColumn("Organisation information", "", [...getOrganisationInfoColumn1(fieldPrefix), ...getOrganisationCategoriesColumn(fieldPrefix)]),
        new EasyFormColumn("\u200B", "", getOrganisationInfoColumn2(fieldPrefix)) // \u200B is a zero-width space to make sure the columns are aligned
    ])
}

export function getOrganisationInfoColumn1(fieldPrefix?: string) {
    return [
        new FieldHeaderRender({ displayText: "Basic information" }),
        new TextFieldRender({
            displayText: "Name",
            fieldName: (fieldPrefix ?? "") + "name",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Address",
            fieldName: (fieldPrefix ?? "") + "address",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "CVR number",
            fieldName: (fieldPrefix ?? "") + "cvr",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Remark",
            fieldName: (fieldPrefix ?? "") + "comment",
            type: "text",
            uniqueId: ""
        }),
    ];
}

export function getOrganisationCategoriesColumn(fieldPrefix?: string) {
    return [
        new FieldHeaderRender({ displayText: "Categories" }),
        new AutocompleteFieldRender({
            displayText: "Overall category",
            fieldName: (fieldPrefix ?? "") + "overall_category",
            getOptionLabelFunc: (option: OverallCategoryEnum) => option.toString(),
            options: Object.values(OverallCategoryEnum),
            uniqueId: "no_id"
        }),
        new AutocompleteFieldRender({
            displayText: "Specific category",
            fieldName: (fieldPrefix ?? "") + "specific_category",
            getOptionLabelFunc: (option: SpecificCategoryEnum) => option.toString(),
            options: Object.values(SpecificCategoryEnum),
            uniqueId: "no_id"
        }),
    ];
}

export function getOrganisationInfoColumn2(fieldPrefix?: string) {
    return [
        new FieldHeaderRender({ displayText: "Invoice details" }),
        new TextFieldRender({
            displayText: "EAN-number",
            fieldName: (fieldPrefix ?? "") + "invoice.ean",
            type: "number",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Email",
            fieldName: (fieldPrefix ?? "") + "invoice.email",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Reference",
            fieldName: (fieldPrefix ?? "") + "invoice.reference",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Debitor",
            fieldName: (fieldPrefix ?? "") + "invoice.debitor",
            type: "text",
            uniqueId: ""
        }),
        new TextFieldRender({
            displayText: "Notes",
            fieldName: (fieldPrefix ?? "") + "invoice.note",
            type: "text",
            uniqueId: ""
        }),
    ]
}